import apiClient from './client';
import { User } from '../types/Auth';
import { API_ENDPOINTS } from './endpoints';

interface LoginResponse {
    access_token: string;
    refresh_token: string;
}

export const login = async (credentials: { email: string; password: string }): Promise<LoginResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.LOGIN, credentials);
    return response.data;
};

export const getProfile = async (): Promise<User> => {
    const response = await apiClient.get(API_ENDPOINTS.PROFILE);
    return response.data;
};

export const logout = async (): Promise<void> => {
    try {
        await apiClient.post(API_ENDPOINTS.LOGOUT);
    } catch (error) {
        console.error('Server logout failed, but proceeding with client-side logout.', error);
    } finally {
        console.log('Logging out');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
    }
};
